import { render } from "./HomeOurHistyory.html?vue&type=template&id=10215de8&scoped=true&ts=true&external"
import script from "./HomeOurHistyory.ts?vue&type=script&lang=ts&external"
export * from "./HomeOurHistyory.ts?vue&type=script&lang=ts&external"

import "./HomeOurHistyory.scss?vue&type=style&index=0&id=10215de8&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10215de8"]])

export default __exports__